const UploaderTypes = {
  ADD_FILES_IN_QUEUE_UPLOADER: 'ADD_FILES_IN_QUEUE_UPLOADER',
  UPLOADFILE_PERCENTAGE_STATUS: 'UPLOADFILE_PERCENTAGE_STATUS',
  UPDATE_CROPPED_IMAGE_LOADER: 'UPDATE_CROPPED_IMAGE_LOADER',
  CLEAR_UPLOADER_FILES: 'CLEAR_UPLOADER_FILES',
  REMOVE_TASK_FROM_LIST: 'REMOVE_TASK_FROM_LIST',
  SET_UPLOADER_QUEUE_SUMMARY: 'SET_UPLOADER_QUEUE_SUMMARY',
  UPLOAD_COMPLETED_PING: 'UPLOAD_COMPLETED_PING',
};

export default UploaderTypes;
